module.exports = __webpack_public_path__ + "img/phone.5d8c5fe1.png";